module.exports = __webpack_public_path__ + "static/media/3DPPA43.54d8cbd5.jpg";